exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".worklist-item-marker svg{width:100%;height:100%;vertical-align:unset}\n", "", {"version":3,"sources":["D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/worklistsLayer/D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/worklistsLayer/D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/worklistsLayer/worklistItemMarker.scss"],"names":[],"mappings":"AAAA,0BAEI,WACA,YACA,oBAAqB,CAAA","file":"worklistItemMarker.scss","sourcesContent":[".worklist-item-marker {\r\n  svg {\r\n    width: 100%;\r\n    height: 100%;\r\n    vertical-align: unset;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports
